import { render, staticRenderFns } from "./CounterItem.vue?vue&type=template&id=88d62626"
import script from "./CounterItem.vue?vue&type=script&lang=js"
export * from "./CounterItem.vue?vue&type=script&lang=js"
import style0 from "./CounterItem.vue?vue&type=style&index=0&id=88d62626&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88d62626')) {
      api.createRecord('88d62626', component.options)
    } else {
      api.reload('88d62626', component.options)
    }
    module.hot.accept("./CounterItem.vue?vue&type=template&id=88d62626", function () {
      api.rerender('88d62626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/waybillKanbanBoard/component/CounterItem.vue"
export default component.exports